export class TransactionDetails {
    totalAmtByAllTypes: number = 0;
    balance: number = 0;
    refundAmt: number = 0; 
}
